'use client';

import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { declension } from '@/shared/utils/declension';

export const CountdownTimer = ({
	targetDate,
	theme,
}: {
	targetDate: Date | null;
	theme: 'dark' | 'light';
}) => {
	const [timeLeft, setTimeLeft] = useState({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	});

	useEffect(() => {
		if (!targetDate) return;

		const timer = setInterval(() => {
			const now = new Date().getTime();
			const distance = targetDate.getTime() - now;

			if (distance > 0) {
				setTimeLeft({
					days: Math.floor(distance / (1000 * 60 * 60 * 24)),
					hours: Math.floor(
						(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
					),
					minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
					seconds: Math.floor((distance % (1000 * 60)) / 1000),
				});
			}
		}, 1000);

		return () => clearInterval(timer);
	}, [targetDate]);

	return (
		<div className="flex items-center justify-center gap-2 font-mono text-2xl">
			<div className="text-center">
				<div
					className={clsx('text-3xl font-bold', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{String(timeLeft.days).padStart(2, '0')}
				</div>
				<div
					className={clsx('text-xs opacity-70', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{declension(timeLeft.days, ['день', 'дня', 'дней'])}
				</div>
			</div>
			<div
				className={clsx({
					'text-white': theme === 'dark',
					'text-gray-800': theme === 'light',
				})}
			>
				:
			</div>
			<div className="text-center">
				<div
					className={clsx('text-3xl font-bold', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{String(timeLeft.hours).padStart(2, '0')}
				</div>
				<div
					className={clsx('text-xs opacity-70', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{declension(timeLeft.hours, ['час', 'часа', 'часов'])}
				</div>
			</div>
			<div
				className={clsx({
					'text-white': theme === 'dark',
					'text-gray-800': theme === 'light',
				})}
			>
				:
			</div>
			<div className="text-center">
				<div
					className={clsx('text-3xl font-bold', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{String(timeLeft.minutes).padStart(2, '0')}
				</div>
				<div
					className={clsx('text-xs opacity-70', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{declension(timeLeft.minutes, ['минута', 'минуты', 'минут'])}
				</div>
			</div>
			<div
				className={clsx({
					'text-white': theme === 'dark',
					'text-gray-800': theme === 'light',
				})}
			>
				:
			</div>
			<div className="text-center">
				<div
					className={clsx('text-3xl font-bold', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{String(timeLeft.seconds).padStart(2, '0')}
				</div>
				<div
					className={clsx('text-xs opacity-70', {
						'text-white': theme === 'dark',
						'text-gray-800': theme === 'light',
					})}
				>
					{declension(timeLeft.seconds, ['секунда', 'секунды', 'секунд'])}
				</div>
			</div>
		</div>
	);
};
